import { STAKKO_ACCOUNT_URL, STAKKO_STRIPE_LINKS } from './config';
import type { StakkoCheckoutKind } from './config';

export interface StakkoCheckoutOptions {
  uid: string;
  email?: string | null;
}

/**
 * Stripe Payment Link + identita uživatele.
 * `client_reference_id` je klíč, podle kterého Make.com zapíše
 * `vibiz_entitlements/{uid}`.
 */
export function buildStakkoCheckoutUrl(
  link: string,
  options: StakkoCheckoutOptions,
): string {
  if (!link) return '';
  try {
    const url = new URL(link);
    url.searchParams.set('client_reference_id', options.uid);
    if (options.email) {
      url.searchParams.set('prefilled_email', options.email);
    }
    return url.toString();
  } catch {
    return link;
  }
}

/**
 * Otevře Stripe checkout. Když link není nakonfigurovaný, otevře účetní
 * stránku, aby uživatel neskončil na mrtvém tlačítku.
 */
export function startStakkoCheckout(
  kind: StakkoCheckoutKind,
  options: StakkoCheckoutOptions,
): boolean {
  const link = STAKKO_STRIPE_LINKS[kind];
  if (typeof window === 'undefined') return false;

  if (!link) {
    window.open(STAKKO_ACCOUNT_URL, '_blank', 'noopener');
    return false;
  }

  window.open(buildStakkoCheckoutUrl(link, options), '_blank', 'noopener');
  return true;
}
